module.exports = __webpack_public_path__ + "static/media/arrow-alt-down.92a8721a.svg";